import React from 'react';
import ContactForm from '../components/ContactForm';
import Divider from '../components/Divider';
import GoogleMap from '../components/GoolgeMap';

export default class Contact extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div>
                <Divider />
                <div className={'container'}>
                    <ContactForm />
                </div>
                <Divider />
                <GoogleMap />
            </div>
        );
    }
}

Contact.propTypes = {};



// WEBPACK FOOTER //
// ./src/routes/Contact.jsx